export function postsFilter($) {
  jQuery(document).ready(function ($) {
    function getQueryParam(param) {
      var urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(param);
    }
    var filterButtons = document.querySelectorAll(".filter-button");
    var posts = document.querySelectorAll(".post-item");
    var loadMoreButton = document.getElementById("load-more-button");
    var postsToShow = 8; // Initial number of posts to display

    // Function to display posts based on current filter and count
    function updatePosts(category) {
      var visibleCount = 0;
      posts.forEach(function (post) {
        var matchesCategory = category === "all" || post.classList.contains(category);
        var withinLimit = visibleCount < postsToShow;
        if (matchesCategory && withinLimit) {
          post.style.display = "block";
          visibleCount++;
        } else {
          post.style.display = "none";
        }
      });

      // Hide Load More button if all matching posts are visible
      var totalMatchingPosts = Array.from(posts).filter(function (post) {
        return category === "all" || post.classList.contains(category);
      }).length;
      if (loadMoreButton) {
        loadMoreButton.style.display = visibleCount < totalMatchingPosts ? "block" : "none";
      }
    }
    if (filterButtons) {
      // Event listener for category buttons
      filterButtons.forEach(function (button) {
        button.addEventListener("click", function () {
          var category = button.getAttribute("data-category");

          // Set active button
          if (document.querySelector(".filter-button.active")) {
            document.querySelector(".filter-button.active").classList.remove("active");
          }
          button.classList.add("active");

          // Reset post count and update posts
          postsToShow = 8;
          updatePosts(category);
        });
      });
      if (loadMoreButton) {
        // Event listener for Load More button
        loadMoreButton.addEventListener("click", function () {
          postsToShow += 8; // Show 8 more posts
          var activeCategory = document.querySelector(".filter-button.active").getAttribute("data-category");
          updatePosts(activeCategory);
        });
      }
      // Initialize with all posts visible
      updatePosts("all");
      var categoryFromURL = getQueryParam("category");
      if (categoryFromURL) {
        var matchingFilterButton = document.querySelector(".filter-button[data-category=\"".concat(categoryFromURL, "\"]"));
        if (matchingFilterButton) {
          matchingFilterButton.click(); // Simulate a click on the matched button
        } else {
          var _document$querySelect;
          (_document$querySelect = document.querySelector('.filter-button')) === null || _document$querySelect === void 0 || _document$querySelect.click(); // Default to "All" if no match
        }
      } else {
        var _document$querySelect2;
        (_document$querySelect2 = document.querySelector('.filter-button')) === null || _document$querySelect2 === void 0 || _document$querySelect2.click(); // Default to "All" if no category in URL
      }
    }
  });
  jQuery(document).ready(function ($) {
    var loadMoreButton = document.getElementById('load-more-cards');
    var postsShown = 12; // Initial posts shown
    var filteredPosts = []; // This will store the filtered posts for loading more

    // Function to reset and filter posts based on selected term
    function filterPosts(selectedTerm) {
      var posts = document.querySelectorAll('.key-player.filtered');
      posts.forEach(function (post) {
        var postTerms = post.getAttribute('data-term'); // Get the terms for the post (stored in data attribute)

        if (selectedTerm === 'all' || postTerms.includes(selectedTerm)) {
          post.style.setProperty('display', 'none', 'important'); // Initially hide all posts
          filteredPosts.push(post); // Add to the filtered posts list
        } else {
          post.style.setProperty('display', 'none', 'important'); // Hide posts that don't match
        }
      });

      // Show the first 2 filtered posts
      filteredPosts.slice(0, 12).forEach(function (post) {
        return post.style.setProperty('display', 'flex', 'important');
      });
      postsShown = 12; // Reset the postsShown counter after filtering
      loadMoreButton.style.display = 'inline-block'; // Show the "Load More" button again
      if (filteredPosts.length <= 12) {
        loadMoreButton.style.display = 'none'; // Hide "Load More" if there are no more filtered posts to load
      }
    }

    // Filter posts when a filter button is clicked
    var filterButtons = document.querySelectorAll('.filter-button2');
    filterButtons.forEach(function (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault(); // Prevent default link behavior
        // Remove the active class from all buttons
        filterButtons.forEach(function (btn) {
          return btn.classList.remove('active');
        });

        // Add the active class to the clicked button
        this.classList.add('active');
        var selectedTerm = this.getAttribute('data-term');

        // Clear the filteredPosts array and reset the visibility of posts
        filteredPosts = [];

        // Apply the filter
        filterPosts(selectedTerm);
      });
    });
    if (loadMoreButton) {
      // "Load More" functionality
      loadMoreButton.addEventListener('click', function () {
        // Show the next 2 filtered posts
        for (var i = postsShown; i < postsShown + 12 && i < filteredPosts.length; i++) {
          filteredPosts[i].style.setProperty('display', 'flex', 'important');
        }
        postsShown += 12;

        // If all filtered posts are shown, hide the "Load More" button
        if (postsShown >= filteredPosts.length) {
          loadMoreButton.style.display = 'none'; // Hide the button when no more posts are available
        }
      });
    }
    function getQueryParam(param) {
      var urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(param);
    }
    var categoryFromURL = getQueryParam('category');
    if (categoryFromURL) {
      // Find the filter button that matches the category in the URL
      var matchingFilterButton = document.querySelector(".filter-button2[data-term=\"".concat(categoryFromURL, "\"]"));
      if (matchingFilterButton) {
        matchingFilterButton.click(); // Trigger a click event on the matched button
      } else {
        var _document$querySelect3;
        // If no match is found, default to "All"
        (_document$querySelect3 = document.querySelector('.filter-button2')) === null || _document$querySelect3 === void 0 || _document$querySelect3.click();
      }
    } else {
      var _document$querySelect4;
      // If no category is in the URL, default to "All"
      (_document$querySelect4 = document.querySelector('.filter-button2')) === null || _document$querySelect4 === void 0 || _document$querySelect4.click();
    }
  });
}